// extracted by mini-css-extract-plugin
export default {"formButton":"ButtonLighth_formButton__Tpeqc"};